// App name: Check if use is comment on a post purpose
// Description:
//


const CommentApp = (function ($) {

  // variables
  let _commentButton = $('.post_custom__toggleform');
  // init
  function init() {
    //
    commentStatus()
  }

  //function name
  function commentStatus() {
    if (_commentButton.length) {
      _commentButton.each(function(){
        var post_id = $(this).data('post-id');
        if(Cookies.get('comment_'+post_id)) {
          $(this).addClass('active');
        }
      })
    }
  }

  return {
    init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  CommentApp.init();
});
